import type { Email} from "@@/shared/email";
import { emailZodSchema } from "@@/shared/email";
import type { Address} from "@@/shared/locations/address";
import { addressZodSchema } from "@@/shared/locations/address";
import type { Phone} from "@@/shared/phone";
import { phoneZodSchema } from "@@/shared/phone";
import { z } from "zod";

type HomeDeliveryOrigin = {
    readonly _type: "HOME_DELIVERY_ORIGIN";
    readonly senderId: string;
    readonly senderName: string;
    readonly type: "USER" | "PROVIDER";
    readonly contact: {
        readonly email: Email;
        readonly phone: Phone;
    };
    readonly notesToDeliverer: string;
    readonly address: Address;
};

const homeDeliveryOriginZodSchema: z.ZodSchema<HomeDeliveryOrigin> = z.object({
    _type: z.literal("HOME_DELIVERY_ORIGIN"),
    senderId: z.string().min(1),
    senderName: z.string().min(1),
    type: z.enum(["USER", "PROVIDER"]),
    contact: z.object({
        email: emailZodSchema,
        phone: phoneZodSchema,
    }),
    notesToDeliverer: z.string().min(1),
    address: addressZodSchema,
});

export { homeDeliveryOriginZodSchema };
export type { HomeDeliveryOrigin };
